export const estimate_details = [
  {
    key:"1",
    Client_Name: "Michael Walker",
    Image: "user-09.jpg",
    Roll: "CEO",
    Company_Name: "BrightWave Innovations",
    Estimate_Date: "14 Jan 2024",
    Expiry_Date: "15 Jan 2024",
    Amount: "$3000",
    Status: "Accepted",
  },
  {
    key:"2",
    Client_Name: "Sophie Headrick",
    Image: "user-40.jpg",
    Roll: "Manager",
    Company_Name: "Stellar Dynamics",
    Estimate_Date: "21 Jan 2024",
    Expiry_Date: "25 Jan 2024",
    Amount: "$2500",
    Status: "Sent",
  },
  {
    key:"3",
    Client_Name: "Cameron Drake",
    Image: "user-41.jpg",
    Roll: "Director",
    Company_Name: "Quantum Nexus",
    Estimate_Date: "20 Feb 2024",
    Expiry_Date: "22 Feb 2024",
    Amount: "$2800",
    Status: "Expired",
  },
  {
    key:"4",
    Client_Name: "Doris Crowley",
    Image: "user-42.jpg",
    Roll: "Consultant",
    Company_Name: "EcoVision Enterprises",
    Estimate_Date: "15 Mar 2024",
    Expiry_Date: "17 Mar 2024",
    Amount: "$3300",
    Status: "Accepted",
  },
  {
    key:"5",
    Client_Name: "Thomas Bordelon",
    Image: "user-44.jpg",
    Roll: "Manager",
    Company_Name: "Aurora Technologies",
    Estimate_Date: "12 Apr 2024",
    Expiry_Date: "16 Apr 2024",
    Amount: "$3600",
    Status: "Declined",
  },
  {
    key:"6",
    Client_Name: "Kathleen Gutierrez",
    Image: "user-45.jpg",
    Roll: "Director",
    Company_Name: "BlueSky Ventures",
    Estimate_Date: "20 May 2024",
    Expiry_Date: "21 May 2024",
    Amount: "$2000",
    Status: "Sent",
  },
  {
    key:"7",
    Client_Name: "Bruce Wright",
    Image: "user-46.jpg",
    Roll: "CEO",
    Company_Name: "TerraFusion Energy",
    Estimate_Date: "06 Jul 2024",
    Expiry_Date: "06 Jul 2024",
    Amount: "$3400",
    Status: "Expired",
  },
  {
    key:"8",
    Client_Name: "Estelle Morgan",
    Image: "user-47.jpg",
    Roll: "Manager",
    Company_Name: "UrbanPulse Design",
    Estimate_Date: "02 Sep 2024",
    Expiry_Date: "04 Sep 2024",
    Amount: "$4000",
    Status: "Declined",
  },
  {
    key:"9",
    Client_Name: "Stephen Dias",
    Image: "user-48.jpg",
    Roll: "CEO",
    Company_Name: "Nimbus Networks",
    Estimate_Date: "15 Nov 2024",
    Expiry_Date: "15 Nov 2024",
    Amount: "$4500",
    Status: "Accepted",
  },
  {
    key:"10",
    Client_Name: "Angela Thomas",
    Image: "user-43.jpg",
    Roll: "Consultant",
    Company_Name: "Epicurean Delights",
    Estimate_Date: "10 Dec 2024",
    Expiry_Date: "11 Dec 2024",
    Amount: "$3800",
    Status: "Sent",
  },
];
